import { render, staticRenderFns } from "./juryImageViewer.vue?vue&type=template&id=6bab2f74&scoped=true"
import script from "./juryImageViewer.vue?vue&type=script&lang=js"
export * from "./juryImageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab2f74",
  null
  
)

export default component.exports